import gql from 'graphql-tag';
import { ADDRESS_VIEW_MODEL_FRAGMENT, PAGINATION_VIEW_MODEL_FRAGMENT } from 'shared';

export const GET_CUSTOMERS = gql`
  query GetCustomers($input: CustomersByAccountIdInput!) {
    customer {
      customersByAccountId(input: $input) {
        error
        success
        pagination {
          ...PaginationMetaViewModel
        }
        items {
          id
          name
          type
          phone
          status
          accountType
          activeDealsNumber
          totalRevenueAmount
          opportunitiesNumber
          lastContactDate #latestTransactionDate
          deliveryAddress {
            ...AddressFields
          }

          billingAddress {
            ...AddressFields
          }
        }
      }
    }
  }
  ${ADDRESS_VIEW_MODEL_FRAGMENT}
  ${PAGINATION_VIEW_MODEL_FRAGMENT}
`;
